const config = {
  demo: "",
  apiEnd22:
    process.env.REACT_APP_API_END22 ||
    "https://testqds.com/new_quicklease/public//storage/",
  apiEndPointtest:
    process.env.REACT_APP_API_ENDPOINT_TEST ||
    "http://192.168.18.124/test_quicklease/api/",
  apiEndPoint: process.env.REACT_APP_API_ENDPOINT || "",
  apiEndPoint2:
    process.env.REACT_APP_API_ENDPOINT_2 ||
    "https://testqds.com/new_quicklease/api/",
};

export default config;
